import { render, staticRenderFns } from "./MaterialMappers.vue?vue&type=template&id=23fd8b1d&"
import script from "./MaterialMappers.vue?vue&type=script&lang=js&"
export * from "./MaterialMappers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports